import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import { useLogin } from "@/features/auth/repositories/auth-repository";;
import { LoginSchema, TLoginSchema } from "@/features/auth/forms/schema";

import Button from "@/components/buttons/Button";
import TextInput from "@/components/form-controls/TextInput"



const LoginForm = () => {
    const navigate = useNavigate();

    const loginMutation = useLogin(
        () => navigate("/dashboard", { replace: true })
    );

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(LoginSchema),
        defaultValues: {
            username: "",
            password: ""
        }
    });

    const submit = (data: TLoginSchema) => {
        loginMutation.mutate({
            username: data.username,
            password: data.password
        });
        
    }

    return (
        <form 
            className="space-y-8" 
            onSubmit={handleSubmit(submit)}
        >
            <div className="space-y-4">
                <TextInput 
                    label="Email"
                    placeholder="example@gmail.com"
                    hasError={errors.username?.type != undefined}
                    error={errors.username?.message?.toString()}
                    register={register("username")}
                />

                <TextInput
                    label="Password" 
                    placeholder="password"
                    type="password"
                    hasError={errors.password?.type != undefined}
                    error={errors.password?.message?.toString()}
                    register={register("password")}
                /> 
            </div>


            <Button intent={"primary"} loading={loginMutation.isPending} size={"md"} className="w-full">
                Sign In
            </Button>

            <div className="text-sm text-secondary">
                <span>Don't have an account?</span>
                <Link 
                    to="/auth/register/personal"
                    className="text-primary hover:underline pl-2"
                >
                    Click here to register
                </Link>
            </div>
        </form>
    )
}

export default LoginForm